<style>
    .holder {
        line-height: 2em;
        padding: 40px;
        background-color: whitesmoke;
        overflow: scroll;
        padding-top: 20px;
    }

    .incoming-items-table {
        width: 100%;
        border-collapse: collapse;
        color: rgb(85, 85, 85);
    }

    td,th {
        padding: 15px;
        text-align: left;
    }

    th {
        padding-top: 0px;
    }

    td {
        border-top: 1px solid whitesmoke;
    }

    tr {
        cursor: pointer;
    }

    tr:hover {
        background-color: whitesmoke; 
    }

    .header-row:hover {
        background-color: white;
    }

    .header-row {
        color: black;
    }

    .myChart {
        max-width: 400px;
    }

    .box {
        background-color: white;
        border-radius: 10px;
        box-shadow: 0px 2px 4px lightgrey;
        padding: 20px;
        margin: 15px;
        min-height: 250px;
        font-size: 14px;
    }

    .row {
        margin: 30px;
        display: flex;
    }

    h1 {
        font-size: 1em;
    }

    .title {
        font-size: 18px;
        margin-bottom: -5px;
        margin-left: 25px;
        color: black;
    }

    .cell {
        flex:1;
    }

    .summary {
        font-size: 18px;
        color: grey;
    }

    .emphasis {
        color: black;
    }

    .type-badge {
        padding: 5px;
        border-radius: 10px;
        color: white;
        font-size: 12px;
        display: inline-block;
        line-height: 1em;
        width: 90px;
        text-align: center;
    }

    .news {
		background-color:rgb(196, 127, 0);
	}

	.suggestion {
		background-color: #0676cd;
	}

	.criticism {
		background-color: rgb(163, 0, 0);
	}

	.praise {
		background-color: rgb(36, 185, 36);
    }

    .municipal {
        background-color: black;
    }

    .tab {
        margin-right: 25px;
        color: rgb(173, 173, 179);
        cursor: pointer;
        user-select: none;
    }

    .tab:hover {
        color: rgb(112, 112, 134);
    }

    .tab-selected {
        color: black;
    }

    .empty {
        position: relative;
        color: rgb(175, 175, 175);
        font-size: 18px;
        width: 100%;
        height: 100%;
        padding-top: 50px;
        text-align: center;
    }
</style>

<script>
	import {onMount, afterUpdate} from 'svelte'
    import {push, location} from '../pt-router/Router.svelte'
	import * as Common from '../Common.js'
    import NavBar from '../NavBar.svelte';

    import OfficialItemRow from '../MunicipalTools/OfficialItemRow.svelte'

    import DoughnutItemGraphWidget from '../MunicipalTools/DoughnutItemGraphWidget.svelte'
    import BarItemGraphWidget from '../MunicipalTools/BarItemGraphWidget.svelte'
    
    export let params;

    let holder = null
    let scrollTopId = null
    let scrollTopValue = null

    let items = []
    let comments = []
    let handledItems = {}
    let incomingItemsArray = []
    let handledItemsArray = []
    let officialItems = []

    let startDateInput = null
    let endDateUnix = Math.floor((new Date()).getTime() / 1000)
    let startDateUnix = endDateUnix + (60 * Common.SECONDS_IN_A_DAY)

    $: openedTab = params.id
    $: items && function(h) {
        incomingItemsArray = items.filter(i => !(i.item_id in h))
    }(handledItems)
    $: items && function(h) {
        handledItemsArray = items
        .filter(i => (i.item_id in h))
        .map(i => {
            i.comment_id = h[i.item_id].comment_id
            i.handleditem_id = h[i.item_id].id
            return i
        })
        .sort((a,b) => {
            return a.handleditem_id < b.handleditem_id
        })
    }(handledItems)
        
    function activate() {
        let cachedData = Common.getCachedFeed("tools")
        if(cachedData) {
            items = cachedData.data.items
            handledItems = cachedData.data.handledItems
            officialItems = cachedData.data.officialItems
            comments = cachedData.data.comments
            scrollTopId = cachedData.scrollTopId
            scrollTopValue = cachedData.scrollTopValue
            Common.clearCachedFeed("tools")
        } else {
            Common.getData('tools/area/' + currentUserArea.id + '/items' + '?startdate=' + startDateUnix)
            .then(data => {
                items = data
            })

            Common.getData('tools/area/' + currentUserArea.id + '/handleditems' + '?startdate=' + startDateUnix)
            .then(data => {
                for(let i in data) {
                    handledItems[data[i].item_id] = data[i]
                }
            })

            Common.getData('tools/area/' + currentUserArea.id + '/officialitems' + '?startdate=' + startDateUnix)
            .then(data => {
                officialItems = data
            })

            Common.getData('tools/area/' + currentUserArea.id + '/comments' + '?startdate=' + startDateUnix)
            .then(data => {
                comments = data
            })
        }
    }

    let currentUser;
    let currentUserArea;
    const unsubsribe = Common.currentUser.subscribe(value => {
        currentUser = value
        if(currentUser && currentUser.user_area_id != 0){
            Common.getData('area/' + currentUser.user_area_id)
            .then(data => {
                currentUserArea = data
                activate()
            })
        }
        if((currentUser && currentUser.user_area_id===0) || currentUser === undefined) {
            +window.addEventListener('unload', function () {});
            window.location.replace('https://plantogether.city/tools-landing')
        }
    })

    onMount(async () => {
        if(Common.isMobile()) {
            alert("Hi there! The Plan Together Municipal Tools are designed to be used on Desktop. Please use one for the correct experience.")
        }

        var now = new Date();
        now.setDate(now.getDate()-60);

        if(startDateInput.valueAsDate) {
            startDateInput.valueAsDate = now
        } else {
            startDateInput.value = now.toISOString().slice(0, 10);
        }

        startDateUnix = Math.floor(now.getTime() / 1000);
        
        Common.updateLoggedInUser(() => {
            currentUser = Common.currentUserValue
            if(currentUser && currentUser.user_area_id != 0){
                Common.getData('area/' + currentUser.user_area_id)
                .then(data => {
                    currentUserArea = data
                    activate()
                })
            }
            if((currentUser && currentUser.user_area_id===0) || currentUser === undefined) {
                +window.addEventListener('unload', function () {});
                window.location.replace('https://plantogether.city/tools-landing')
            }
            })
    })

    afterUpdate(() => {
        if(scrollTopId) {
            let elem = document.getElementById(scrollTopId)
            if(elem) {
                holder.scrollTop = scrollTopValue
                scrollTopId = null
            }
        }
    })

    function ignoreItem(e, item_id) {
        e.stopPropagation()
        Common.postData("tools/area/" + currentUserArea.id + "/ignoreitem/" + item_id)
        .then(r => {
            if(!r.ok) {
                alert("Problem ignoring item.")
                return
            }
            let handledItemID = Number(r.data)
            handledItems[item_id] = {id: handledItemID, item_id: item_id, comment_id: 0}
            Common.CreateNotification({body: "Marked Item as Seen."}, 1000)
        })
    }

    function goToItem(item_id) {
        Common.setCachedFeed("tools", {
            scrollTopValue: holder.scrollTop,
            scrollTopId: item_id,
            data: {
                items: items,
                handledItems: handledItems,
                officialItems: officialItems,
                comments: comments
            }
        })
        push('/item/' + item_id)
    }

    function goToComment(item_id, comment_id) {
        Common.setCachedFeed("tools", {
            scrollTopValue: holder.scrollTop,
            scrollTopId: item_id,
            data: {
                items: items,
                handledItems: handledItems,
                officialItems: officialItems,
                comments: comments
            }
        })
        push('/comment/' + comment_id)
    }

    function updateStartDate(e) {
        if(!startDateInput.value) {
            return
        }

        let x = (startDateInput.valueAsDate) ?
            (startDateInput.valueAsDate.getTime() / 1000) :
            (new Date(startDateInput.value).getTime() / 1000)

        startDateUnix = Math.floor(x)
        activate()
    }

</script>
<div bind:this={holder} class="holder">
    <div class="row">
            <div style="padding-left: 20px;">From<input bind:this={startDateInput} on:change={updateStartDate} style="margin-left: 10px; margin-right: 10px; font-size: 14px;" type="date"><span>to Now</span></div>
    </div>
    {#if currentUser && currentUserArea}
    <div class="row">
        <div>
            <div class="title">Item Types</div>
            <div class="box">
                <DoughnutItemGraphWidget {items}></DoughnutItemGraphWidget>
            </div>
        </div>
        <div>
            <div class="title">Interactions Levels</div>
            <div class="box">
                <BarItemGraphWidget {items}></BarItemGraphWidget>
            </div>
        </div>
        <div class="cell">  
            <div class="title">Summary for {currentUserArea.name}</div>
            <div class="box summary">
                Welcome, {currentUser.user_name}! In the past <span class="emphasis">{Math.ceil((endDateUnix - startDateUnix)/Common.SECONDS_IN_A_DAY)} days</span>, there have been <span class="emphasis">{items.length} Items</span> and <span class="emphasis">{comments.length} comments</span> contributed.
                <p>
                    <button style="font-size:14px;" on:click={() => push('/add-item/1001')}>Add Official Item To Map</button><br>
                    <button style="font-size:14px;" on:click={() => push('/area/'+currentUserArea.id)}>Go To Area on Map</button><br>
                    <button style="font-size:14px;" on:click={() => push('/areaadmin/'+currentUserArea.id)}>Update Area Profile</button>
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="cell">
            <div class="title">
                <span class={"tab" + (openedTab === 'incoming' ? ' tab-selected' : '')} on:click={() => push('/tools/incoming')}>
                    Incoming Items
                </span>
                <span class={"tab" + (openedTab === 'handled' ? ' tab-selected' : '')} on:click={() => push('/tools/handled')}>
                    Handled Items
                </span>
                <span class={"tab" + (openedTab === 'posted' ? ' tab-selected' : '')} on:click={() => push('/tools/posted')}>
                    Posted Items
                </span>
            </div>
                <div class="box">
                    {#if openedTab === 'incoming'}
                        {#if incomingItemsArray.length === 0}
                            <div class="empty">All caught up!</div>
                        {:else}
                            <table class="incoming-items-table">
                                <tr class="header-row">
                                    <th>Id</th>
                                    <th>Create Time</th>
                                    <th>Type</th>
                                    <th>Title</th>
                                    <th>Likes</th>
                                    <th>Actions</th>
                                </tr>
                                
                                {#each incomingItemsArray as item}
                                <tr id={item.item_id} on:click={() => goToItem(item.item_id)}>
                                    <td>{item.item_id}</td>
                                    <td style="white-space: nowrap">{Common.UnixTimeToDateStr(item.item_createtime)}</td>
                                    <td>
                                        <div class="type-badge" style={"background-color:" + Common.getItemTypeColorString(item.item_type) + ";"}>
                                            {Common.getItemTypeString(item.item_type)}
                                        </div>
                                    </td>
                                    <td>{item.item_title}</td>
                                    <td>{item.item_likes}</td>
                                    <td>
                                        <button on:click={(e) => ignoreItem(e, item.item_id)}>Mark as Seen</button>
                                    </td>
                                </tr>
                                {/each}
                            </table>
                        {/if}
                    {:else if openedTab === 'handled'}
                        {#if handledItemsArray.length === 0}
                            <div class="empty">No handled items, yet.</div>
                        {:else}
                            <table class="incoming-items-table">
                                <tr class="header-row">
                                    <th>Id</th>
                                    <th>Create Time</th>
                                    <th>Type</th>
                                    <th>Title</th>
                                    <th>Likes</th>
                                    <th>Handled</th>
                                </tr>
                                
                                {#each handledItemsArray as item}
                                <tr id={item.item_id} on:click={() => goToItem(item.item_id)}>
                                    <td>{item.item_id}</td>
                                    <td style="white-space: nowrap">{Common.UnixTimeToDateStr(item.item_createtime)}</td>
                                    <td>
                                        <div class="type-badge" style={"background-color:" + Common.getItemTypeColorString(item.item_type) + ";"}>
                                            {Common.getItemTypeString(item.item_type)}
                                        </div>
                                    </td>
                                    <td>{item.item_title}</td>
                                    <td>{item.item_likes}</td>
                                    <td>
                                        {#if item.comment_id === 0}
                                            <i>Seen</i>
                                        {:else}
                                            <a on:click={(e) => {goToComment(item.item_id, item.comment_id), e.stopPropagation()}}>comment/{item.comment_id}</a>
                                        {/if}
                                    </td>
                                </tr>
                                {/each}
                            </table>
                        {/if}
                    {:else if openedTab === 'posted'}
                        {#if officialItems.length === 0}
                            <div class="empty">No posted items, yet.</div>
                        {:else}
                            <table class="incoming-items-table">
                                <tr class="header-row">
                                    <th>Id</th>
                                    <th>Create Time</th>
                                    <th>Type</th>
                                    <th>Title</th>
                                    <th>Likes</th>
                                    <th>Responses</th>
                                    <th>Actions</th>
                                </tr>
                                
                                {#each officialItems as item}
                                    <OfficialItemRow {item} {currentUserArea} {goToItem}></OfficialItemRow>
                                {/each}
                            </table>
                        {/if}
                    {/if}
            </div>
        </div>
    </div>
    {/if}
</div>